<template>
  <ResumableUploader
    v-slot="{
      openFileSelector,
      retry,
      errors: uploadErrors,
      message,
      uploading,
      percentage,
    }"
    class="add-package-to-release"
    accept=".apk"
    :disabled="addingToRelease"
    :upload-url="apkUploadPath"
    @upload-done="addPackageToRelease"
  >
    <div
      v-if="message || uploadErrors.length"
      class="add-package-to-release__retry"
    >
      <span>{{ $t('FILE_UPLOAD.FAILED') }}</span>

      <ElButton
        class="add-package-to-release__retry-button"
        type="text"
        icon="el-icon-refresh"
        @click="retry"
      >
        {{ $t('RETRY') }}
      </ElButton>
    </div>

    <ErrorsList
      v-if="errors.length || uploadErrors.length"
      :errors="[...uploadErrors, ...errors]"
      class="add-package-to-release__error-list"
    />

    <div class="add-package-to-release__container flex-container align-middle">
      <ElButton
        icon="el-icon-plus"
        size="small"
        :loading="uploading || addingToRelease"
        @click="openFileSelector"
      >
        {{ $t('APP.RELEASES.ADD_PACKAGE') }}
      </ElButton>

      <ElProgress
        v-if="uploading || addingToRelease"
        class="add-package-to-release__progress"
        :width="100"
        :stroke-width="4"
        :percentage="percentage"
        :status="percentage === 100 ? 'success' : null"
      />
    </div>
  </ResumableUploader>
</template>

<script>
import ResumableUploader from '@@/common/file-uploaders/ResumableUploader';
import { APK_UPLOAD_PATH } from '@/api/file-uploader/endpoints';
import packageName from '@/mixins/packageName';
import ErrorsList from '@@/common/ErrorsList';

import { Release } from '@/api/api';

export default {
  name: 'AddPackageToRelease',
  components: {
    ResumableUploader,
    ErrorsList,
  },
  mixins: [packageName],
  props: {
    releaseId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
      addingToRelease: false,
    };
  },
  computed: {
    apkUploadPath() {
      return APK_UPLOAD_PATH;
    },
  },
  methods: {
    addPackageToRelease(responses) {
      const { apk } = responses[0];
      this.addingToRelease = true;
      return Release.addPackageToRelease({
        apk,
        releaseId: this.releaseId,
        packageName: this.packageName,
      })
        .then(({ package: packageItem, message }) => {
          this.$message.success(message);
          this.$emit('add-package', packageItem);
        })
        .catch(({ message }) => {
          if (message) {
            this.errors = [message];
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.addingToRelease = false;
        });
    },
  },
};
</script>

<style lang="scss">
.add-package-to-release {
  padding: $global-padding 0;

  &__error-list {
    padding: $global-padding/2;
  }

  &__retry {
    padding: $global-padding/2;
    font-size: $lb-small-font-size;
  }

  &__retry-button {
    margin: 0 $global-margin;
    font-size: $lb-small-font-size 1.1;
    color: $lb-color-alert;

    &:hover,
    &:focus {
      color: $lb-color-alert;
    }
  }

  &__add-package {
    flex-grow: 1;
  }

  &__progress {
    direction: ltr;
    flex-grow: 1;
    text-align: left;
    padding-left: 10px;

    .el-progress-bar__inner {
      background-color: $--color-info;

      &.is-success {
        background-color: $lb-color-primary;
      }
    }
  }
}
</style>
